import React from 'react';
import { ExternalLink } from 'lucide-react';
import useLinkPreview from '../../../hooks/useLinkPreview';

export default function CrmChatLinkPreview({ url, isMine = false }) {
  const { preview, loading } = useLinkPreview(url);

  if (!url || (!loading && !preview)) return null;

  if (loading && !preview) {
    return (
      <div
        className={`mt-2 rounded-xl overflow-hidden border animate-pulse ${
          isMine ? 'border-emerald-500/40 bg-emerald-700/30' : 'border-border bg-background/60'
        }`}
      >
        <div className={`h-28 ${isMine ? 'bg-emerald-700/40' : 'bg-muted'}`} />
        <div className="p-2 space-y-1.5">
          <div className={`h-3 w-2/3 rounded ${isMine ? 'bg-emerald-600/50' : 'bg-muted'}`} />
          <div className={`h-2.5 w-full rounded ${isMine ? 'bg-emerald-600/40' : 'bg-muted'}`} />
        </div>
      </div>
    );
  }

  if (!preview) return null;

  const domain = preview.domain || preview.site_name || '';
  const title = preview.title || domain || url;
  const description = preview.description || '';

  return (
    <a
      href={preview.url || url}
      target="_blank"
      rel="noopener noreferrer"
      className={`mt-2 block rounded-xl overflow-hidden border no-underline transition-opacity hover:opacity-95 ${
        isMine ? 'border-emerald-500/40 bg-emerald-700/30' : 'border-border bg-background/70'
      }`}
    >
      {preview.image ? (
        <div className="w-full max-h-36 overflow-hidden bg-black/10">
          <img
            src={preview.image}
            alt=""
            className="w-full h-auto max-h-36 object-cover"
            loading="lazy"
            referrerPolicy="no-referrer"
            onError={(e) => {
              e.currentTarget.style.display = 'none';
            }}
          />
        </div>
      ) : null}
      <div className="p-2.5 min-w-0">
        {domain ? (
          <div
            className={`text-[10px] uppercase tracking-wide truncate mb-0.5 ${
              isMine ? 'text-emerald-100/70' : 'text-muted-foreground'
            }`}
          >
            {domain}
          </div>
        ) : null}
        <div
          className={`text-xs font-semibold line-clamp-2 ${
            isMine ? 'text-white' : 'text-foreground'
          }`}
        >
          {title}
        </div>
        {description ? (
          <div
            className={`text-[11px] line-clamp-2 mt-0.5 ${
              isMine ? 'text-emerald-50/85' : 'text-muted-foreground'
            }`}
          >
            {description}
          </div>
        ) : null}
        <div
          className={`inline-flex items-center gap-1 text-[10px] mt-1 ${
            isMine ? 'text-emerald-100/80' : 'text-muted-foreground'
          }`}
        >
          <ExternalLink className="h-3 w-3" />
          Open link
        </div>
      </div>
    </a>
  );
}
